import React, { useState } from "react";
import { FileDownload, LibraryBooks, ListAlt } from "@mui/icons-material";

import { useCanViewBomComparison } from "fond/hooks/useCanViewBom";
import BomComparisonModal from "fond/project/bom/BomComparisonModal";
import BomModalSwitch from "fond/project/bom/BomModalSwitch";
import { Project } from "fond/types";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

interface DesignArtifactsPanelProps {
  project: Project;
}

const DesignArtifactsPanel: React.FC<DesignArtifactsPanelProps> = ({ project }) => {
  const { open } = useStackedNavigationContext();
  const [isBomModalOpen, setIsBomModalOpen] = useState(false);
  const [isBomComparisonModalOpen, setIsBomComparisonModalOpen] = useState(false);
  const canViewBomComparison = useCanViewBomComparison(project);

  return (
    <>
      <StackedNavigationButton
        data-testid="view-bill-of-materials-button"
        icon={<ListAlt />}
        title="Bill of materials"
        subtitle="View design bill of materials"
        sx={{ m: 0 }}
        onClick={() => setIsBomModalOpen(true)}
      />
      {canViewBomComparison && (
        <StackedNavigationButton
          data-testid="view-bom-comparison-button"
          icon={<LibraryBooks />}
          title="Compare bills of materials"
          subtitle="Compare BOMs across all designs"
          sx={{ m: 0, mt: 1 }}
          onClick={() => setIsBomComparisonModalOpen(true)}
        />
      )}
      <StackedNavigationButton
        data-testid="export-construction-prints-button"
        icon={<FileDownload />}
        title="Construction prints"
        subtitle="Export construction prints"
        sx={{ m: 0, mt: 1 }}
        onClick={() => open("mu-construction-prints-export")}
      />
      {isBomModalOpen && <BomModalSwitch project={project} architecture={null} onClose={() => setIsBomModalOpen(false)} />}
      {isBomComparisonModalOpen && <BomComparisonModal project={project} architecture={null} onClose={() => setIsBomComparisonModalOpen(false)} />}
    </>
  );
};

export default DesignArtifactsPanel;
